<template>
  <div id="forgot">
    <h3 class="title">忘记密码</h3>
    <van-field
      label="手机号"
      placeholder="请输入手机号"
      v-model="forgotForm.mobile"
    ></van-field>
    <van-field
      label="验证码"
      placeholder="请输入验证码"
      v-model="forgotForm.code"
    >
      <van-button
        slot="button"
        :disabled="codeDisabled"
        size="small"
        type="primary"
        @click="getCode"
      >
        发送验证码{{ count }}
      </van-button>
    </van-field>
    <van-field
      label="密码"
      placeholder="请设置密码"
      v-model="forgotForm.password"
    ></van-field>
    <van-field
      label="确认密码"
      placeholder="确认密码"
      v-model="forgotForm.checkPwd"
    ></van-field>
    <div class="btn">
      <van-button type="danger" plain @click="toLogin">返回登陆</van-button>
      <van-button type="danger" @click="submit">提交并登陆</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "forgotPwd",
  data() {
    return {
      forgotForm: {
        userId: "",
        mobile: "",
        code: "",
        password: "",
        checkPwd: "",
        loginType: 5
      },
      count: "",
      codeDisabled: false,
      mark: 'yq'
    };
  },
  mounted() {
    if(this.$route.query.mark) {
      this.mark = this.$route.query.mark
    }
    localStorage.setItem('yhb_mark', this.mark)
    this.$cookie.set('yhb_mark', this.mark)
  },
  methods: {
    getCode() {
      this.$axios({
        url: "user/captcha",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        },
        params: {
          mobile: this.forgotForm.mobile
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.codeDisabled = true;
          let TIME_COUNT = 60;
          let count = TIME_COUNT;
          this.count = "(" + TIME_COUNT + ")";
          this.timer = setInterval(() => {
            if (count > 1 && count <= TIME_COUNT) {
              count--;
              this.count = "(" + count + ")";
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.codeDisabled = false;
              this.count = "";
            }
          }, 1000);
        }
      });
    },
    //判断是否是微信登录
    isWxLogin() {
      if (
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 微信推送
    wxLogin() {
      let params = {
        params: {
          userId: this.userId,
          loginType: 5,
          wechatMark: this.$wechatMark
        }
      };
      // 根据手机号获取openId
      this.$axios.post("weixin/get/openid", params).then(res => {
        if (res.data.code === 200) {
          if (res.data.data == null || res.data.data == "") {
            let params1 = {
              wechatMark: this.$wechatMark,
              callback: "https://yq.cg1717.com/wxCallback.html"
            };
            // 微信授权
            this.$axios
              .get("weixin/getCodeUrl", { params: params1 })
              .then(res => {
                window.location.href = res.data.data;
              });
          } else {
            this.$router.push("/preorder?mark=" + this.mark);
          }
        }
      });
    },
    submit() {
      let all = Object.keys(this.forgotForm).every(val => {
        return this.forgotForm[val];
      });
      if (!all) {
        Toast({
          message: "请输入完整信息!",
          duration: 2000
        });
        return false;
      }
      if (this.forgotForm.password !== this.forgotForm.checkPwd) {
        Toast({
          message: "两次输入密码不一样!",
          duration: 2000
        });
        return false;
      }
      this.$axios.post("user/check", { params: this.forgotForm }).then(res => {
        if (res.data.code === 200) {
          this.$axios({
            url: "user/retrieve/password",
            params: this.forgotForm,
            headers: {
              "Content-Type": "application/form-data;charset=utf-8"
            },
            method: "post"
          }).then(res => {
            if (res.data.code === 200) {
              this.$axios
                .post("auth/token", { params: this.forgotForm })
                .then(res => {
                  if (res.data.code === 200) {
                    let params = {
                      params: "TRANSPORT_WAY"
                    };
                    this.$axios.post("dict/info", params).then(res => {
                      if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                          val.name = val.dictName;
                        });
                        this.$store.commit({
                          type: "getDict",
                          t: "transport",
                          list: d
                        });
                      }
                    });
                    params = {
                      params: "PACK_NAME_TYPE"
                    };
                    this.$axios.post("dict/info", params).then(res => {
                      if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                          val.name = val.dictName;
                        });
                        this.$store.commit({
                          type: "getDict",
                          t: "pack",
                          list: d
                        });
                      }
                    });
                    params = {
                      params: "PAY_MEANS_TYPE"
                    };
                    this.$axios.post("dict/info", params).then(res => {
                      if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                          val.name = val.dictName;
                        });
                        this.$store.commit({
                          type: "getDict",
                          t: "pay",
                          list: d
                        });
                      }
                    });
                    params = {
                      params: "DELIVERY_TYPE"
                    };
                    this.$axios.post("dict/info", params).then(res => {
                      if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                          val.name = val.dictName;
                        });
                        this.$store.commit({
                          type: "getDict",
                          t: "delivery",
                          list: d
                        });
                      }
                    });
                    params = {
                      params: "TRACKING_STATUS"
                    };
                    this.$axios.post("dict/info", params).then(res => {
                      if (res.data.code === 200) {
                        let d = res.data.data;
                        d.forEach(val => {
                          val.name = val.dictName;
                        });
                        this.$store.commit({
                          type: "getDict",
                          t: "status",
                          list: d
                        });
                      }
                    });
                    let data = res.data.data;
                    this.forgotForm.userId = data.accid;
                    localStorage.setItem(
                      "yhb_token",
                      JSON.stringify({
                        token: data.token_type + " " + data.access_token
                      })
                    );
                    localStorage.setItem("yhb_phone", this.forgotForm.mobile);
                    localStorage.setItem("yhb_userId", this.forgotForm.userId);
                    localStorage.setItem(
                      "yhb_rememberPhone",
                      this.forgotForm.mobile
                    );
                    this.$cookie.set(
                      "yhb_token",
                      JSON.stringify({
                        token: data.token_type + " " + data.access_token
                      })
                    );
                    this.$cookie.set("yhb_phone", this.forgotForm.mobile);
                    this.$cookie.set("yhb_userId", this.forgotForm.userId);
                    this.$store.commit("getToken");
                    if (this.isWxLogin()) {
                      this.wxLogin();
                    } else {
                      this.$router.push("/user");
                    }
                  }
                });
            }
          });
        }
      });
    },
    toLogin() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
#forgot {
  .title {
    background-color: #fff;
    font-size: 0.45rem;
    text-align: center;
    padding: 0.425rem 0;
  }
  .btn {
    display: flex;
    justify-content: space-between;
    padding: 0 0.5rem;
    .van-button {
      width: 40%;
    }
  }
}
</style>
